<template>
	<app-page>
		<app-heading :title="isNew ? 'New Template' : template.name" />
		<app-form @submit="onSubmit">
			<app-section class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-templates' }">Cancel</app-button>
				</app-section-actions>
				<div class="title">Basic informations</div>
				<app-row>
					<app-cell cols="12" sm="4">
						<input-text
							label="Name"
							v-model="template.name"
							required
							:errors="errors.name"
						/>
					</app-cell>
					<app-cell cols="12" sm="4">
						<input-text
							label="Slug"
							v-model="template.slug"
							required
							:errors="errors.slug"
							:disabled="!isNew"
						/>
					</app-cell>
				</app-row>
				<app-divider class="ma-4" />
				<div class="title">Localization & Currency</div>
				<app-row>
					<app-cell cols="12" sm="4">
						<input-locale
							label="Locales"
							v-model="template.locales"
							required
							multiple
							:errors="errors.locales"
							:preferred="['en','fr']"
						/>
					</app-cell>
				</app-row>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			template: {
				name: '',
				slug: '',
				locales: [],
			},
			errors: {},

			currencies: [{
				text: 'US Dollars',
				value: 'USD',
			}, {
				text: 'Canadian Dollars',
				value: 'CAD',
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.template
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.template = await this.$ravello.request()
					.v(2)
					.to('websitetemplates')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		getRequestPayload() {
			return {
				name: this.template.name,
				slug: this.template.slug,
				locales: this.template.locales,
			}
		},

		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request().v(2).to('websitetemplates').create(this.getRequestPayload(true))
				} else {
					await this.$ravello.request().v(2).to('websitetemplates').to(this.id)
						.update(this.getRequestPayload())
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', 'Template'
					+ ` successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-templates' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
